import { type ChangeEvent, type FC } from 'react';

import { IconSettings } from '@tabler/icons-react';
import {
  ButtonField,
  SelectField,
  Smokebreak,
} from '@wk/components-react16';

import { ENVIRONMENTS } from '@/config/constants';

import type { Application, Evaluation } from '@/types';

import ApplicationDetailsFields from './ApplicationDetailsFields';
import ApplicationDetailsTrend from './ApplicationDetailsTrend';

interface ApplicationDetailsMobilePanelProps {
  application?: Application;
  evaluationTrendData: Array<{
    generatedAt: string;
    score: number;
  }>;
  hasEvaluationTrendData: boolean;
  isOpen: boolean;
  latestEvaluation?: Evaluation;
  selectedEnvironment: string;
  onClose: () => void;
  onEnvironmentChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  onNavigateToConfiguration: () => void;
}

const ApplicationDetailsMobilePanel: FC<ApplicationDetailsMobilePanelProps> = ({
  application,
  evaluationTrendData,
  hasEvaluationTrendData,
  isOpen,
  latestEvaluation,
  selectedEnvironment,
  onClose,
  onEnvironmentChange,
  onNavigateToConfiguration,
}) => (
  <Smokebreak
    isOpen={isOpen}
    position="right"
    toFocus='[data-e2e="cg-smokebreak-close"]'
    onUserRequest={onClose}
  >
    <h2 slot="smokebreakHeader" className="p-3 font-semibold text-lg">
      Application Details
    </h2>
    <div slot="smokebreakBody" className="p-3">
      <div className="flex flex-col gap-4">
        <SelectField size="small">
          <select value={selectedEnvironment} onChange={onEnvironmentChange}>
            {ENVIRONMENTS.map((environment) => (
              <option key={environment} value={environment}>
                {environment}
              </option>
            ))}
          </select>
        </SelectField>
        <div className="application-details-mobile-config-button w-full">
          <ButtonField size="small">
            <button onClick={onNavigateToConfiguration}>
              <IconSettings size={14} />
              View Configuration
            </button>
          </ButtonField>
        </div>
        <ApplicationDetailsFields
          application={application}
          latestEvaluation={latestEvaluation}
        />
        <ApplicationDetailsTrend
          className="w-full flex flex-col gap-4"
          evaluationTrendData={evaluationTrendData}
          hasEvaluationTrendData={hasEvaluationTrendData}
        />
      </div>
    </div>
  </Smokebreak>
);

export default ApplicationDetailsMobilePanel;
